import { defineElement } from "@amzn/exs-elements/web-component";
import definition from "./definition";

defineElement(definition);
